import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../Services/AppContext';
import { loadDOMComponent } from '../../../helpers';
import { store } from '../../../store/store';
import React from 'react';
import { Provider } from 'react-redux';
import AclContextProvider from '../../../Modules/Acl/Components/AclContextProvider';
import ORSMRootWrapper from './ORSMRootWrapper';

loadDOMComponent({
	selector: 'react-orsm',
	callback: ({ container }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<ORSMRootWrapper />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
